export const riskProfileDeclaration =
  'I/We hereby confirm that such investment is in accordance with my/our needs, and I/We am/are investing in the above referred portfolio basis is/our professional skills and my/our own assessment of the risk involved in the portfolio.';
export const autoCreditDeclarationText =
  'I/We authorise you to receive credits automatically into my/our account :';
export const sectionFilledByInvestor = 'To be filled by investor';
